import { makeStyles } from 'tss-react/mui';

export const useCheckMarkImageStyles = makeStyles()(() => ({
  root: {
    width: 120,
    height: 120,
  },
}));
